export class BaseConfig {
    protected applyConfig(conf: object): void {
        Object.assign(this, conf);
    }
}




